import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import Home from "../pages/Home";
import News from "../features/News/News";
import FullNews from "../features/News/FullNews";

import DynamicDeputet from "../components/Dynamic/DynamicDeputet";

import Struktura from "../features/structure/CompoundStructure";
import Diplomaci from "../features/Diplomaci/CompoundDiplomaci";
import StruktureIndex from "../features/structure/StruktureIndex";
import DiplomaciIndex from "../features/Diplomaci/DiplomaciIndex";
import Filters from "../features/DocumentsFilters/index";
import AkteIndex from "../features/DocumentsFilters/AkteIndex";
import Deputetet from "../pages/Deputetet/index";
import Slider from "../components/Sliders/Slider";
import SliderSmall from "../components/Sliders/SliderSmall";
import Kryefaqe from "../features/Kryefaqe/index";
import NewTabs from "../components/NewTabs/index";
import ScrollToTop from "./ScrollToTop";

class Main extends Component {
  render() {
    return (
      <div style={{ height: "auto", minHeight: "800px" }}>
        <ScrollToTop>
          <Switch>
            <Route exact path="/newTabs" component={NewTabs} />
            <Route exact path="/kryefaqe" component={Kryefaqe} />
            <Route exact path="/deputetet" component={Deputetet} />
            <Route exact path="/akte" component={Filters} />
            <Route exact path="/deputet" component={DynamicDeputet} />
            <Route exact path="/diplomacia" component={Diplomaci} />
            <Route exact path="/diplomacia/:id" component={DiplomaciIndex} />
            <Route exact path="/struktura" component={Struktura} />
            <Route exact path="/struktura/:id" component={NewTabs} />
            <Route exact path="/akte/:id" component={AkteIndex} />
            <Route exact path="/news/:id" component={FullNews} />
            <Route exact path="/news" component={News} />
            <Route path="/slider" component={Slider} />
            <Route path="/sliderSmall" component={SliderSmall} />
            <Route path="/" component={Home} />
          </Switch>
        </ScrollToTop>
      </div>
    );
  }
}
export default Main;
